import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationProps, NotificationsService } from 'src/app/core/service/notifications.service';
import { NgClass } from "@angular/common";
import { FRONT_URLS } from "../../../../util/common/url-parts";

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  imports: [
    NgClass,
  ],
  standalone: true,
})
export class NotificationComponent implements OnInit {
  private _destroyStream: Subject<void> = new Subject<void>();
  private notificationService = inject(NotificationsService);
  private router = inject(Router);

  notifications: NotificationProps[] = [];
  mobileDesign = false;

  ngOnInit(): void {
    this.notificationService.notification.pipe(takeUntil(this._destroyStream)).subscribe((notificationProps) => {
      if (!notificationProps) {
        return;
      }
      this.setNotificationAnimationDuration(notificationProps.timeout);
      this.notifications.push(notificationProps);
      this.mobileDesign = this.checkIfMobileDesignUsed();
      setTimeout(() => {
        if (this.notifications.length) {
          this.notifications.shift();
        }
      }, notificationProps.timeout);
    });
  }

  /**
 * Checks if the current route should use the mobile design.
 * @returns {boolean} - `true` if the route uses the mobile design; otherwise, `false`.
 *  * @example
 *  Assuming ROUTES_FOR_MOBILE_VERSION = ['/login', '/dashboard']
 *  and the current route is '/login?user=123':
 * this.router.url = '/login?user=123';
 * checkIfMobileDesignUsed() => returns true
 */
  private checkIfMobileDesignUsed(): boolean {
    const url = this.router.url.split('?')[0];
    return ROUTES_FOR_MOBILE_VERSION.some((route) => url.includes(route));
  }

  private setNotificationAnimationDuration(timeout): void {
    document.documentElement.style.setProperty('--notification-animation-duration', timeout + 'ms');
  }
}

const ROUTES_FOR_MOBILE_VERSION = [FRONT_URLS.LOGIN, FRONT_URLS.ENTRANCE];
